import "core-js/modules/es.function.name.js";
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Card from 'components/Card';
import Modal from 'components/Modal';
import UserBadgeImage from 'components/UserBadgeImage';
import PageTitle from 'components/PageTitle';
import Sparkles from 'components/Sparkles';
import Button from 'components/Button';
import Panel from 'components/Panel';
import { ModalCloseButton } from 'components/ModalHeadline';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function PlaylistCompletionModal(_ref) {
  var playlist = _ref.playlist,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _ref2 = playlist || {},
    badge = _ref2.badge;
  var hasBadge = (badge === null || badge === void 0 ? void 0 : badge.id) && !(badge !== null && badge !== void 0 && badge.isDeleted);
  var titleId = 'playlist-completion';
  var title = t('title_congratulations');
  var message = hasBadge ? /*#__PURE__*/_jsxs(Trans, {
    t: t,
    i18nKey: "modal_playlist_completion_message_with_badge",
    values: {
      name: playlist === null || playlist === void 0 ? void 0 : playlist.name
    },
    children: ["Playlist completed, you have unlocked the", /*#__PURE__*/_jsxs("strong", {
      children: ["\"", playlist === null || playlist === void 0 ? void 0 : playlist.name, "\""]
    }), " badge!"]
  }) : /*#__PURE__*/_jsxs(Trans, {
    t: t,
    i18nKey: "modal_playlist_completion_message_no_badge",
    values: {
      name: playlist === null || playlist === void 0 ? void 0 : playlist.name
    },
    children: ["You have completed the ", /*#__PURE__*/_jsxs("strong", {
      children: ["\"", playlist === null || playlist === void 0 ? void 0 : playlist.name, "\""]
    }), " playlist!"]
  });
  var pageTitle = hasBadge ? /*#__PURE__*/_jsx(PageTitle, {
    id: titleId,
    children: title
  }) : /*#__PURE__*/_jsx(Sparkles, {
    children: /*#__PURE__*/_jsx(PageTitle, {
      id: titleId,
      children: title
    })
  });
  return /*#__PURE__*/_jsx(Modal, {
    id: "".concat(titleId, "-modal"),
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      children: [/*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsx(ModalCloseButton, {
          onClick: onClose
        })
      }), hasBadge && /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: /*#__PURE__*/_jsx(Sparkles, {
          children: /*#__PURE__*/_jsx(UserBadgeImage, {
            badge: badge,
            hasUserBadge: true,
            size: 100
          })
        })
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: pageTitle
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: message
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onClose,
          children: t('actions_close')
        })
      })]
    })
  });
}
export default PlaylistCompletionModal;